import HBSwiper from "@/components/HBSwiper";
import BoardCardNew from "../BoardCardNew";
import styles from "./index.module.less";

interface SameBoardOperationCardProps {
  record: {
    pinId: string;
    boards: any[];
    currentBoardId?: string | number; // 新增：当前采集所在画板的ID
  };
  columnSize: number;
  customColumnNum?: number;
  stackIndex?: number; // 新增：弹窗堆栈索引，用于生成唯一key
}

export default function SameBoardOperationCard({
  record,
  columnSize,
  customColumnNum,
  stackIndex = 0,
}: SameBoardOperationCardProps) {
  const colNum = Math.max(3, customColumnNum || 3);

  return (
    <div
      key={`boardOperation-${stackIndex}-${record.pinId}`}
      className={`board-operation-wrapper ${styles.sameBoardOperation}`}
      style={{
        width: columnSize * colNum + 16 * (colNum - 1), // 保持动态宽度计算
      }}
    >
      <div className={styles.title}>同在画板</div>
      <div className={styles.content}>
        <HBSwiper
          className={styles.swiper}
          contentClassName={styles.swiperContent}
          iconClassName={styles.icon}
          hideGradient={true}
        >
          {record.boards.map((board, idx) => {
            const isCurrentBoard =
              idx === 0 &&
              record.currentBoardId &&
              board?.board_id === record.currentBoardId;

            return (
              <div
                key={`${stackIndex}-${board.board_id || idx}`}
                className={styles.boardCard}
              >
                <BoardCardNew
                  record={board}
                  hideButton={true}
                  hideUser={true}
                  location={idx + 1}
                  viewSource={isCurrentBoard ? record.pinId : undefined} // 只有「所在画板」才传递 viewSource
                  stackIndex={stackIndex}
                  isCurrentBoard={isCurrentBoard} // 传递是否是所在画板
                />
              </div>
            );
          })}
        </HBSwiper>
      </div>
    </div>
  );
}
